
import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Params, Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { filter } from 'rxjs/operators';

import { GlobalVarService, UiFeedbackService } from '@core/services';
import { SpinnerComponent } from '@shared/components';
import { Subscription } from 'rxjs';
import { enableComputerUse, selectDesktopUse } from './store';
import { ErrorModalComponent } from '@shared/ui';
/**
 * Componenten principal donde se aloja el router-outlet
 ** Creado por: JMT
 ** Fecha: 10/04/2023
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    NgxUiLoaderModule,
    SpinnerComponent,
    ErrorModalComponent
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  readonly #activatedRoute = inject(ActivatedRoute);
  readonly #router = inject(Router);
  readonly #store = inject(Store);
  readonly #deviceDetectorService = inject(DeviceDetectorService);
  readonly #globalVarService = inject(GlobalVarService);
  readonly #uiFeedback = inject(UiFeedbackService);

  #isMobile = this.#deviceDetectorService.isMobile();
  #allowDesktopUse = this.#store.selectSignal(selectDesktopUse);
  #subscrition: Subscription | null = null;

  showOutlet = computed(() => this.#globalVarService.showOutlet());
  showApp = computed(() => (this.#isMobile || this.#allowDesktopUse()));

  showErrorModal = computed(() => this.#uiFeedback.errorModalVisible());
  errorData = computed(() => this.#uiFeedback.errorData());

  ngOnInit(): void {
    if (this.showOutlet() && !this.showApp()) {
      this.getQueryParams();
    }

    this.getCurrentPath();
  }

  ngOnDestroy(): void {
    this.#subscrition?.unsubscribe();
  }

  onCloseErrorModal() {
    console.log('soy yo');
    this.#uiFeedback.closeErrorModal();
  }


  private getQueryParams() {
    this.#subscrition = this.#activatedRoute.queryParams
      .pipe(
        filter(params => Object.keys(params).length > 0) // Solo pasa si hay parámetros
      )
      .subscribe((params: Params) => {
        if (params.hasOwnProperty('desktop')) {
          this.#store.dispatch(enableComputerUse({ computerUse: true }));
        } else {
          this.#store.dispatch(enableComputerUse({ computerUse: this.#allowDesktopUse() }))
        }
      })
  }

  private getCurrentPath() {
    this.#router.events
      .pipe(
        filter(event => event instanceof NavigationStart)
      )
      .subscribe((response: any) => {
        const { url } = response;
        const parsedURL = url?.toLowerCase();

        const isSellerPath = parsedURL.includes('login') || parsedURL === '/' || parsedURL.includes('/?desktop');

        if (!isSellerPath) {
          localStorage.setItem('currentPath', url);
        }
      }
      );
  }
}
